<template>
  <div class="AfterSales safe-distance-top-header">
    <Header :pageTitle="title" />

    <div class="AfterSales_bottom">
      <div class="text">
        您好，我是您的专属客服。如需进行{{ title }}服务，请使用微信扫一扫添加客服。
      </div>
      <div>
        <div class="img">
          <!-- 固定 -->
          <img src="https://kpp.cnknowledge.com/group2/M00/0B/3F/rBF-bmS-LWaAJx83AAENB_xYsbU146.png" alt="">
        </div>
        <div class="phone">咨询电话（图书）：010-82619530</div>
      </div>
      <div v-if="type == 2">
        <div class="img">
          <img src="https://kpp.cnknowledge.com/group1/M00/08/F9/rBETW2S-LWGAdF5nAADyfW9MWYU009.png" alt="">
        </div>
        <div class="phone">咨询电话（会议）：010-82617780</div>
      </div>

    </div>
  </div>
</template>

<script>
import Header from "@/views/mobileView/components/header/index.vue";
export default {
  name: "AfterSales",
  components: {

    Header
  },
  data() {
    return {
      type: null,
      title: ""
    };
  },
  created() {
    this.type = this.$route.query.type;
    this.title = this.type == 1 ? "开具发票" : "退换/售后"

  },
};
</script>

<style lang="scss" scoped>
.AfterSales {
  width: 100vw;
  min-height: 100vh;
  overflow: hidden;
  background: #f5f5f5;

  .AfterSales_top {
    height: 44px;
    display: flex;
    justify-content: center;
    align-items: center;
    background: #fff;
    line-height: 44px;

    .my {
      width: 100px;
      font-size: 18px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #333333;
      background: #fff;
    }
  }

  .AfterSales_bottom {
    width: 94%;

    margin: 0 auto;
    background: #fff;
    border-radius: 8px;
    margin-top: 12px;
    padding-bottom: 40px;

    .text {
      font-size: 15px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #333333;
      line-height: 24px;
      padding: 19px 17px 0px 17px;
    }

    .img {
      text-align: center;
      margin-top: 40px;


      img {
        width: 150px;
        height: 150px;
        background: #333333;
        margin: 0px auto;
      }

    }

    .phone {
      font-size: 13px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #333333;
      line-height: 19px;
      text-align: center;
      margin-top: 11px;
    }
  }
}
</style>